module.exports = __webpack_public_path__ + "img/motor_no52.08789a94.jpg";